import React, { useState, useEffect, useRef } from "react";
import "./KeyList.scss";
const musicKey = [
  "Ab",
  "Abm",
  "A",
  "Am",
  "Bb",
  "Bbm",
  "B",
  "Bm",
  "C",
  "Cm",
  "C#",
  "C#m",
  "D",
  "Dm",
  "Eb",
  "Ebm",
  "E",
  "Em",
  "F",
  "Fm",
  "F#",
  "F#m",
  "G",
  "Gm"
];

const KeyList = ({ changeKey, originalKey }: any) => {
  return (
    <div className="key-select">
      {originalKey && (
        <p className="key-select-item key-select-reset" onClick={() => changeKey(originalKey)}>
          Original ({originalKey})
        </p>
      )}
      {musicKey.map((key, i) => (
        <p className="key-select-item" key={i} onClick={() => changeKey(key)}>
          {key}
        </p>
      ))}
    </div>
  );
};
export default KeyList;
